import type { FieldInputType } from '@lighthouse/core'
import { BlockType, EVENT_TYPE } from '@lighthouse/core'

export const eventTypeName: Record<EVENT_TYPE, string> = {
    [EVENT_TYPE.LOAD]: '加载后',
    [EVENT_TYPE.CLICK]: '当点击时',
    [EVENT_TYPE.CHANGE]: '数据改变时',
    [EVENT_TYPE.SCROLL_BOTTOM]: '滚动到距底部x时',
    [EVENT_TYPE.MOUSE_ENTER]: '鼠标移入时',
    [EVENT_TYPE.MOUSE_LEAVE]: '鼠标移出时',
    [EVENT_TYPE.RECORD_CLICK]: '点击一行时',
    [EVENT_TYPE.SUBMIT]: '表单提交后',
    [EVENT_TYPE.SOCKET]: 'Socket事件',
    [EVENT_TYPE.ENTER]: '按下回车时',
    [EVENT_TYPE.FOCUS]: '聚焦时',
    [EVENT_TYPE.BLUR]: '失焦时',
    [EVENT_TYPE.LOAD_DATA]: '数据加载后',
    [EVENT_TYPE.LEFT_SWIPE]: '左滑结束时',
    [EVENT_TYPE.RIGHT_SWIPE]: '右滑结束时',
    [EVENT_TYPE.PLAY]: '播放时',
    [EVENT_TYPE.TIMER]: '定时器'
}

export const blockEventMap: Record<BlockType | 'page', EVENT_TYPE[]> = {
    page: [EVENT_TYPE.LOAD, EVENT_TYPE.SCROLL_BOTTOM, EVENT_TYPE.TIMER],
    [BlockType.text]: [EVENT_TYPE.CLICK],
    [BlockType.button]: [EVENT_TYPE.CLICK],
    [BlockType.container]: [
        EVENT_TYPE.LOAD,
        EVENT_TYPE.CLICK,
        EVENT_TYPE.MOUSE_ENTER,
        EVENT_TYPE.MOUSE_LEAVE,
        EVENT_TYPE.LEFT_SWIPE,
        EVENT_TYPE.RIGHT_SWIPE
    ],
    [BlockType.fieldGroup]: [],
    [BlockType.divider]: [],
    [BlockType.collapse]: [],
    [BlockType.image]: [EVENT_TYPE.CLICK],
    [BlockType.video]: [],
    [BlockType.audio]: [EVENT_TYPE.PLAY],
    [BlockType.file]: [],
    [BlockType.tabs]: [EVENT_TYPE.CLICK],
    [BlockType.breadcrumb]: [],
    [BlockType.card]: [],
    [BlockType.view]: [EVENT_TYPE.RECORD_CLICK, EVENT_TYPE.LOAD_DATA],
    [BlockType.chart]: [EVENT_TYPE.CLICK],
    [BlockType.formContainer]: [EVENT_TYPE.SUBMIT],
    [BlockType.subForm]: [],
    [BlockType.field]: [],
    [BlockType.floatBox]: [],

    [BlockType.filter]: [],
    [BlockType.iframe]: [],
    [BlockType.qrBarcode]: [EVENT_TYPE.CLICK],
    [BlockType.icon]: [EVENT_TYPE.CLICK],
    [BlockType.onOff]: [EVENT_TYPE.CHANGE],
    [BlockType.userCenter]: [],
    [BlockType.toc]: []
}

export const inputTypeEventMap: Record<FieldInputType, EVENT_TYPE[]> = {
    text: [EVENT_TYPE.ENTER, EVENT_TYPE.FOCUS, EVENT_TYPE.BLUR],
    number: [EVENT_TYPE.ENTER, EVENT_TYPE.FOCUS, EVENT_TYPE.BLUR],
    email: [EVENT_TYPE.ENTER, EVENT_TYPE.FOCUS, EVENT_TYPE.BLUR],
    url: [EVENT_TYPE.ENTER, EVENT_TYPE.FOCUS, EVENT_TYPE.BLUR],
    phoneNumber: [EVENT_TYPE.ENTER, EVENT_TYPE.FOCUS, EVENT_TYPE.BLUR],
    person: [EVENT_TYPE.CHANGE],
    date: [EVENT_TYPE.CHANGE],
    relativeSelect: [EVENT_TYPE.CHANGE],
    cascade: [EVENT_TYPE.CHANGE],
    file: [EVENT_TYPE.CHANGE],
    notes: [],
    checkbox: [EVENT_TYPE.CHANGE],
    slider: [EVENT_TYPE.CHANGE],
    calendar: [EVENT_TYPE.CHANGE]
}
